export const resizeCanvas = (
  canvasImg: HTMLCanvasElement,
  width: number,
  height: number,
  imageEncoding: string
): Promise<Blob | null> => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.style.visibility = "hidden";
    document.body.appendChild(canvas);
    
    const context = canvas.getContext('2d');
    context?.drawImage(
      canvasImg,
      0, 0, canvasImg.width, canvasImg.height,
      0, 0, width, height
    );

    canvas.toBlob(resolve, imageEncoding);
    canvas.remove();
  });
}